import CountryCodes from "@/resources/countrycode";
import Valkyrie, { viEarth } from "@sippy-platform/valkyrie";

import PropTypes from "prop-types";

function CountryFlag({ number, fontSize = "1em", style }) {
  const code = number ? CountryCodes.find((_country) => number.startsWith(_country.phone))?.code : null;

  const flag = code
    ? String.fromCodePoint(
        ...code
          .toUpperCase()
          .split("")
          .map((char) => 127397 + char.charCodeAt()),
      )
    : "";

  if (flag) {
    return <span style={{ fontSize, fontFamily: "Twemoji Country Flags", ...style }}>{flag}</span>;
  }

  return <Valkyrie icon={viEarth} style={{ fontSize, ...style }} />;
}

CountryFlag.propTypes = {
  number: PropTypes.string,
  fontSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  style: PropTypes.object,
};

export default CountryFlag;
